module.exports = __webpack_public_path__ + "static/media/image1.9efe07b3.jpg";